module.exports = __webpack_public_path__ + "images/69d850142ef430ec580f71f2298e8924-illu_carbonSensor.svg";